import { render, staticRenderFns } from "./foreign-investments.vue?vue&type=template&id=53bf6312"
import script from "./foreign-investments.vue?vue&type=script&lang=js"
export * from "./foreign-investments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./locale/foreign-investments-en.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fvercel%2Fpath0%2Fpages%2Fthe-exchange%2Fmarket-information%2Fcompany%2F_SecuritySymbol%2Ftrading%2Fforeign-investments.vue&locale=en&external"
if (typeof block0 === 'function') block0(component)
import block1 from "./locale/foreign-investments-ar.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fvercel%2Fpath0%2Fpages%2Fthe-exchange%2Fmarket-information%2Fcompany%2F_SecuritySymbol%2Ftrading%2Fforeign-investments.vue&locale=ar&external"
if (typeof block1 === 'function') block1(component)

export default component.exports